import { getFetch } from '../utils/fetch';
import { APPS_API } from './config';

export function getApps(data) {
  return getFetch(APPS_API(), data);
}



// WEBPACK FOOTER //
// ./src/api/appApi.js